import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { DialogService } from '../../../shared/services/dialog.service';
import { ManagePriceListService } from './manage-price-list.service';

@Component({
    selector: 'add-price-popup',
    templateUrl: 'add-price-popup.component.html',
    providers: [ManagePriceListService]
})

export class AddPricePopUpComponent implements OnInit {
    public isSuccess = false;
    public priceData = [];
    constructor(public managePriceListService: ManagePriceListService,
        public dialogRef: MdDialogRef<AddPricePopUpComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        const param = {
            centreId: this.data.centreId,
            modelId: this.data.typeId,
            productCategoryId: this.data.productCategoryId
        };
        if(param.modelId !== 'Consultations')
        {
            this.managePriceListService.getAddPriceList(param).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.priceData = data['list'];
                    }
            });
        }
        else{
            this.managePriceListService.getAddPriceListConsultation(param.centreId).subscribe(
                result=>{
                    if(result){
                        this.priceData = result.json();
                    }
                }
            );
        }
    }

    onCloseDialog() {
        this.dialogRef.close(this.isSuccess);
    }

    /**
    * add item to the price list and remove item from priceData if success
    * @param id: the id of item, index: index of item in priceData list
    */
    onAddPrice(item, index) {
        // call API to add item
        // if success then remove item from priceData list
        const param = {
            itemId : item.id,
            name : item.name,
            centreId: this.data.centreId,
            modelId: this.data.typeId,
            itemCategoryId: this.data.productCategoryId
        };
        if(param.modelId !== 'Consultations'){
            this.managePriceListService.addNewPrice(param).subscribe(
                result=>{
                    if(result){
                        this.priceData.splice(index, 1);
                        this.isSuccess = true;
                    }
                }
            );
        }
        else{
            const param1 = {
                consultationFeeId : item.id,
                name : item.name,
                centreId : this.data.centreId,

            };
            this.managePriceListService.addNewPriceConsultation(param1).subscribe(
                result=>{
                    if(result){
                        this.priceData.splice(index, 1);
                        this.isSuccess = true;
                    }
                }
            );
        }

    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-price/add-price-popup.component.ts